import "./home.scss"
import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Container, ToastViewer } from "uitoolkit";
import { useBodyStyle, usePageTitle, useMouseActivityTimeout } from "hooks";
import { Sidebar } from "components/sidebar";
import { useClock } from "../../hooks/useClock";
import { useState } from "preact/hooks";

function getCurrentDateString(): string {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
}

export function HomePage(props: {} & RouterProps) {
    usePageTitle("");
    useBodyStyle("homepage");

    const [isPanelVisible, setPanelVisible] = useState(false);
    const effect: h.JSX.CSSProperties|undefined = undefined; //{backdropFilter: "blur(2px)"};

    const clock = useClock();
    const sidebarActivity = useMouseActivityTimeout();
    
    //const url = "https://images.unsplash.com/photo-1482517967863-00e15c9b44be?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
    //const url = "https://images.unsplash.com/photo-1511783111049-b4c32d7fa8fa?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
    //const url = "https://images.unsplash.com/photo-1486140525285-12e658d9ac0f?q=80&w=1674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
    //const url = "https://images.stockcake.com/public/3/c/f/3cfa7129-c03c-4cf4-82a4-55360342cf49/molecular-structure-representation-stockcake.jpg";
    //const url = "https://wallup.net/wp-content/uploads/2016/01/73218-galaxy-Earth-Milky_Way-stars-space-planet-atmosphere.jpg";
    // https://images.unsplash.com/photo-1676839560107-d15f4b15b766?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D
    //const url = "https://images.unsplash.com/photo-1545735089-fe9e1e4f4569?q=80&w=2433&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
    const url = localStorage.getItem("homebackground");
    const style: h.JSX.CSSProperties|undefined = !url ? undefined : {backgroundSize: "cover", backgroundPosition: "center", backgroundImage: "url(\"" + url + "\")"}

    return (
        <Fragment>
            <Container class="row grow maxheight-100vh overflow-y-hidden">
                <div class={`sidecontainer${sidebarActivity.isAnimating && !isPanelVisible ? ' animating' : ''}${!sidebarActivity.isVisible && !isPanelVisible ? ' hidden' : ''}`}>
                    <Sidebar page="home" onPanelToggled={setPanelVisible} />
                </div>
                <Container class="flex-column overflow-y-auto grow" style={style}>
                    <Container class="gap-16 flex-column grow center" style={effect}>
                        <h1>{clock}</h1>
                        <h2>{getCurrentDateString()}</h2>
                    </Container>
                </Container>
            </Container>
            <ToastViewer />
        </Fragment>
    );
}
